import { createFileRoute } from "@tanstack/react-router";
import OrderDetail from "../../pages/admin/OrderDetail";

export const Route = createFileRoute("/admin/orders/$id")({
  component: OrderDetail,
});
